import { render, staticRenderFns } from "./jd-loading.vue?vue&type=template&id=5f52c7b7&scoped=true"
import script from "./jd-loading.vue?vue&type=script&lang=js"
export * from "./jd-loading.vue?vue&type=script&lang=js"
import style0 from "./jd-loading.vue?vue&type=style&index=0&id=5f52c7b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f52c7b7",
  null
  
)

export default component.exports